import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="search-results-navigation"
export default class extends Controller {
	static targets = ["result"];
	static values = { selectedIndex: Number };
	static classes = ["selected"];

	connect() {
		this.selectedIndexValue = -1;
	}

	next(event) {
		// Skip if user is typing in an input or textarea
		if (this.isTypingInInput()) return;

		event.preventDefault();
		const maxIndex = this.resultTargets.length - 1;
		if (this.selectedIndexValue < maxIndex) {
			this.selectedIndexValue++;
			this.updateSelection();
		}
	}

	previous(event) {
		// Skip if user is typing in an input or textarea
		if (this.isTypingInInput()) return;

		event.preventDefault();
		if (this.selectedIndexValue > 0) {
			this.selectedIndexValue--;
			this.updateSelection();
		} else if (this.selectedIndexValue === -1 && this.resultTargets.length > 0) {
			// If nothing selected yet, select the last item when going up
			this.selectedIndexValue = this.resultTargets.length - 1;
			this.updateSelection();
		}
	}

	open(event) {
		// Skip if user is typing in an input or textarea
		if (this.isTypingInInput()) return;

		event.preventDefault();
		if (this.selectedIndexValue >= 0 && this.selectedIndexValue < this.resultTargets.length) {
			const selectedResult = this.resultTargets[this.selectedIndexValue];
			const link = selectedResult.querySelector("a");
			if (link) {
				link.click();
			}
		}
	}

	updateSelection() {
		// Remove highlight from all results
		this.resultTargets.forEach((result, index) => {
			const link = result.querySelector("a");
			if (index === this.selectedIndexValue) {
				result.classList.add(...this.selectedClasses);
				// Focus the link for accessibility
				if (link) {
					link.focus();
				}
			} else {
				result.classList.remove(...this.selectedClasses);
			}
		});
	}

	isTypingInInput() {
		const activeElement = document.activeElement;
		return activeElement && (activeElement.tagName === "INPUT" || activeElement.tagName === "TEXTAREA");
	}
}
